let header = document.querySelector(".header");
let headerBtn = document.querySelector(".header__btnsMenu");

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"));
});

function noscroll(bool) {
    if (bool) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "";
    }
}

function disableScroll(event) {
    event.preventDefault();
}
